<template>
  <card-seplag titulo="Fiscalização - Conceder acesso">
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
export default {
  name: "atribuirAcessoFiscal",
  components: { CardSeplag },
  data: function () {
    return {
    };
  },

  methods: {
    carregarDados() {
    },

  },  
  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
.buttons {
  font-weight: 650;
  padding: 0.5vw !important;
  width: 12em;
}

.checkbox {
  padding-right: 15px;
  margin-top: 10px;
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}
h4 {
  margin: 1rem auto;
}

#containerCadastroExercicio {
  padding: 1vw;
  border-radius: 5px;
  box-shadow: 1px 3px 8px 0.1px #e0e0e0ce;
}

label {
  margin-top: 1vh;
  margin-bottom: 0.5vh;
  color: gray;
}
</style>